import OverflowTagList from 'components/OverflowTagList';
import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';

type Props = {
  rowData: Pick<SentinelTeam, 'scheduledForDeletionAt'> & {
    platformAccounts: Pick<
      SentinelTeam['platformAccounts'][0],
      'id' | 'sourceId'
    >[];
  };
};

export default function AccountIdCell({
  rowData: { platformAccounts, scheduledForDeletionAt },
}: Props) {
  const { searchString } = useSearchContext();

  const scheduledForDeletionProps = {
    ...(scheduledForDeletionAt && {
      palette: 'pastel' as const,
      color: 'licoriceMousse' as const,
      variant: undefined,
    }),
  };

  const items = platformAccounts.map((platformAccount) => ({
    key: platformAccount.id,
    text: (
      <HighlightText
        text={platformAccount.sourceId}
        searchText={searchString}
      />
    ),
  }));

  return (
    <OverflowTagList
      items={items}
      emptyPlaceholder={null}
      overflowAriaLabel={(hiddenCount) =>
        `Show ${hiddenCount} more account ids`
      }
      tagProps={scheduledForDeletionProps}
    />
  );
}
